import React from "react";
import { Link } from "gatsby";
import { CardWrapper, DateCard, YearCard, FilterNav } from "./elements";
import { formatFuzzyDate, sortObjectsByDate } from "./../../modules/time.js";
import { GatsbyImage } from "gatsby-plugin-image";

const searchThisCorpus = (inDataset, inSearchCorpus, searchFor) => {
  const searchTerms = searchFor
    .toLowerCase()
    .split(" ")
    .filter((x) => x !== "");
  const findFoundTerms = inDataset.map((x, index) => {
    const foundTerms = [];
    for (let i = 0; i < searchTerms.length; i++) {
      if (inSearchCorpus[index].indexOf(searchTerms[i]) > -1) {
        foundTerms[i] = true;
      } else {
        foundTerms[i] = 0;
      }
    }
    return { foundTerms: foundTerms, ...x };
  });

  // console.log(findFoundTerms.map((x) => x.foundTerms));

  const filteredByFound = findFoundTerms.filter((x) => {
    let found = true;
    for (let i = 0; i < searchTerms.length; i++) {
      if (!x.foundTerms[i]) {
        found = false;
      }
    }
    return found;
  });
  // console.log(filteredByFound);
  // const sortedFinds = filteredByFound.sort((x, y) => {
  //   if (x > y) return 1;
  //   if (y > x) return -1;
  //   return 0;
  // });
  // console.log(filteredByFound, sortedFinds);

  return filteredByFound;
};

const addYearCards = (data) => {
  let currentYear = 0;
  const outData = [];
  for (let i = 0; i < data.length; i++) {
    const thisDate = new Date(data[i].date);
    if (thisDate.getFullYear() !== currentYear) {
      currentYear = thisDate.getFullYear();
      outData[outData.length] = { type: "year", year: thisDate.getFullYear() };
    }
    outData[outData.length] = data[i];
  }
  return outData;
};

const DateList = ({ data }) => {
  const [yearlyData, setYearlyData] = React.useState([]);
  const [searchFor, setSearchFor] = React.useState("");
  const [oldSearchFor, setOldSearchFor] = React.useState("AAA");

  const sortedData = sortObjectsByDate(data);
  const sortedCorpus = sortedData.map((x) => `${x.title}`.toLowerCase());

  React.useEffect(() => {
    if (searchFor.length && searchFor !== oldSearchFor) {
      console.log("Searching for: ", searchFor);
      setYearlyData(
        addYearCards(searchThisCorpus(sortedData, sortedCorpus, searchFor))
      );
      setOldSearchFor(searchFor);
    } else {
      if (!searchFor.length && searchFor !== oldSearchFor) {
        console.log("Resetting!");
        setYearlyData(addYearCards(sortedData));
        setOldSearchFor(searchFor);
      }
    }
  }, [searchFor, sortedCorpus, sortedData, oldSearchFor]);

  return (
    <React.Fragment>
      <FilterNav>
        Filter:{" "}
        <input
          type="text"
          onChange={(e) => {
            setSearchFor(e.target.value.toLowerCase());
          }}
        />
      </FilterNav>
      <CardWrapper>
        {data.length && yearlyData.length ? (
          yearlyData.map((object, index) => {
            return object.type === "year" ? (
              <YearCard key={`year-${index}-${searchFor}`}>
                <span>{object.year}</span>
              </YearCard>
            ) : (
              <DateCard
                key={`card-${index}-${searchFor}`}
                objectType={object.type}
              >
                <h2>
                  {object.url && object.url.substring(0, 1) === "/" ? (
                    <Link to={object.url}>{object.title}</Link>
                  ) : (
                    <a href={object.url} target="_blank" rel="noreferrer">
                      {object.title}
                    </a>
                  )}
                </h2>
                <p>
                  {object.isRange
                    ? `${formatFuzzyDate(
                        object.date,
                        object.dateApproximateness
                      )}–${formatFuzzyDate(
                        object.endDate,
                        object.endDateApproximateness ||
                          object.dateApproximateness
                      )}`
                    : formatFuzzyDate(object.date, object.dateApproximateness)}
                </p>
                {object.type === "image" ? (
                  <a href={object.url} target="_blank" rel="noreferrer">
                    {object.original.imageFile &&
                    object.original.imageFile.asset ? (
                      <GatsbyImage
                        image={object.original.imageFile.asset.gatsbyImageData}
                        alt={object.title}
                      />
                    ) : null}
                    {/*<SanityImage
                    asset={object.original.imageFile.asset}
                    width={200}
                    alt={object.title}
                    style={{
                      width: "100%",
                      objectFit: "contain",
                    }}
                  />*/}
                  </a>
                ) : null}
              </DateCard>
            );
          })
        ) : (
          <p>Nothing to show! Try some other filter.</p>
        )}
      </CardWrapper>
    </React.Fragment>
  );
};

export default DateList;
